export class Guid {
  static empty(): string {
    return '00000000-0000-0000-0000-000000000000';
  }
}
